export default __webpack_public_path__ + "static/media/titulo_españa.10bb786c.png";